import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar, useIonViewWillEnter } from "@ionic/react";
import { t } from "i18next";
import { helpCircleOutline } from "ionicons/icons";
import React from "react";
import { ChannelFilterProvider, useChannelFilter } from "../../contexts/ChannelFilterContext";
import { ChannelFilter } from "./components/ChannelFilter";
import { ChannelList } from "./components/ChannelList";
import { CreateChannel } from "./components/CreateChannel";

const MobileChannelList = (props: any) => {
  const { setCurrentFilter } = useChannelFilter();

  useIonViewWillEnter(() => {
    setCurrentFilter("");
  });

  return (
    <>
      <IonHeader translucent={true}>
        <IonToolbar>
          <IonTitle>{t("chats")}</IonTitle>
          <div slot={"start"}>
            <ChannelFilter />
          </div>
          <div slot={"end"}>
            <IonButtons>
              <IonButton fill={"clear"} routerLink={"/contact"}>
                <IonIcon icon={helpCircleOutline} />
              </IonButton>
              <CreateChannel />
            </IonButtons>
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse={"condense"} className={"ion-padding"}>
          <IonToolbar>
            <IonTitle slot={"start"} size={"large"}>
              {t("chats")}
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <ChannelList />
      </IonContent>
    </>
  );
};

export const Mchat = (props: any) => {
  return (
    <IonPage>
      <ChannelFilterProvider>
        <MobileChannelList />
      </ChannelFilterProvider>
    </IonPage>
  );
};
